@use '@lib/assets/styles/main.scss' as *;

$imageSize: 56px;

.notValidatedIcon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: $warning200;
  color: $warning900;

  &:not(:disabled) {
    &:hover,
    &:focus,
    &:active {
      background-color: $warning200;
      color: $warning900;
    }
  }
}

%documentationPreviewLink {
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 0.75;
  }
}

.rowCard {
  .documentationPreview {
    padding-left: 68px;
    position: relative;
    min-height: $imageSize;
    box-sizing: content-box;
    display: flex;
    align-items: center;
    & > div {
      max-width: 100%;
    }
  }

  .documentationPreviewLink {
    @extend %documentationPreviewLink;
  }

  .documentationPreviewImage {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    img {
      overflow: hidden;
      border-radius: 4px;
      border: 1px solid $gray200;
      display: block;
      width: $imageSize;
      height: $imageSize;
      object-fit: cover;
    }
    svg {
      display: none;
    }
  }

  .documentationPreviewNameRow {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
  }

  .documentationPreviewNamePrefix,
  .documentationPreviewNameSuffix {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .documentationPreviewName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  .documentationPreviewInfo {
    display: flex;
    align-items: center;
    color: $gray400;
    padding-top: 4px;
  }

  .documentationPreviewInfoSeparator {
    background-color: $gray400;
    display: block;
    width: 1px;
    height: 16px;
    margin: 0 6px;
  }
}

.documentRowCard {
  width: 100%;

  .documentRowCardWrap {
    background-color: $gray10;
    border-radius: 6px;
    padding: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .documentationPreview {
    padding-left: 68px;
    position: relative;
    min-height: $imageSize;
    box-sizing: content-box;
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    & > div {
      max-width: 100%;
    }
  }

  .documentationPreviewLink {
    @extend %documentationPreviewLink;
  }

  .documentationPreviewImage {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    img {
      overflow: hidden;
      border-radius: 4px;
      border: 1px solid $gray200;
      display: block;
      width: $imageSize;
      height: $imageSize;
      object-fit: cover;
    }
    svg {
      display: none;
    }
  }

  .documentationPreviewNameRow {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
  }

  .documentationPreviewNamePrefix,
  .documentationPreviewNameSuffix {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .documentationPreviewName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  .documentationPreviewInfo {
    display: flex;
    align-items: center;
    color: $gray400;
    padding-top: 4px;
  }

  .documentationPreviewInfoSeparator {
    background-color: $gray400;
    display: block;
    width: 1px;
    height: 16px;
    margin: 0 6px;
  }

  .versionNotesLink {
    color: $blue500;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    white-space: nowrap;
    &:hover {
      text-decoration: underline;
    }
  }
}

.blockCard {
  .documentationPreview {
    border: 1px solid $gray200;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
    & > div {
      max-width: 100%;
    }
  }

  .documentationPreviewLink {
    @extend %documentationPreviewLink;
  }

  .documentationPreviewImage {
    width: 100%;
    display: block;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: block;
      object-fit: cover;
    }
    svg {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .documentationPreviewNameRow {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    margin-bottom: 4px;
  }

  .documentationPreviewNamePrefix,
  .documentationPreviewNameSuffix {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .documentationPreviewName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  .documentationPreviewInfoWrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $gray0;
    padding: 8px;
  }

  .documentationPreviewInfo {
    display: flex;
    align-items: center;
    color: $gray400;
  }

  .documentationPreviewInfoSeparator {
    background-color: $gray400;
    display: block;
    width: 1px;
    height: 16px;
    margin: 0 6px;
  }
}
